<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">Bulk Disburse</h5>
      <button
        type="button"
        class="btn-close"
        ref="modalCloseBtn"
        data-bs-dismiss="modal"
        aria-label="Close"
      >
        <i class="bi bi-x-circle"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="partner-modal-section">
        <div class="form-group">
          <label for="">Select bKash Excel: </label> <br />
          <input
            ref="excelFileInputField"
            type="file"
            class="form-control"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            @change="loadExcel"
          />
        </div>

        <div class="message-section mt-4 mb-2" v-if="bkashPaymentData">
          <div class="text-primary" v-if="bkashPaymentData.length">
            Total <b>{{ bkashPaymentData.length }}</b> data found from the bKash
            excel report.
          </div>
          <div class="text-danger" v-else>
            No data found from the bKash excel report.
          </div>
          <div
            v-if="nonDisbursedMatchedDataWithBkashReport"
            :class="{
              'text-success': nonDisbursedMatchedDataWithBkashReport?.length,
              'text-danger': !nonDisbursedMatchedDataWithBkashReport?.length
            }"
          >
            <b>{{ nonDisbursedMatchedDataWithBkashReport.length }}</b> matched
            with the requested bills.
          </div>
        </div>

        <div class="data-container" v-if="bkashPaymentData?.length">
          <nav>
            <div class="nav nav-tabs partner-nav">
              <button
                class="nav-link active"
                data-bs-toggle="tab"
                data-bs-target="#matched-data"
                type="button"
              >
                Matched Bills
              </button>
              <button
                class="nav-link"
                data-bs-toggle="tab"
                data-bs-target="#all-data"
                type="button"
              >
                All Data
              </button>
            </div>
          </nav>
          <div class="tab-content table-responsive mt-3" id="nav-tabContent">
            <div class="tab-pane fade show active" id="matched-data">
              <table class="table partner-table">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>Transaction ID</th>
                    <th>Name</th>
                    <th>bKash No</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-if="nonDisbursedMatchedDataWithBkashReport?.length"
                  >
                    <tr
                      v-for="(
                        data, index
                      ) in nonDisbursedMatchedDataWithBkashReport"
                      :key="index"
                    >
                      <td>{{ index + 1 }}</td>
                      <td>{{ data.transactionId }}</td>
                      <td>{{ data.name }}</td>
                      <td>{{ data.bkashNo }}</td>
                      <td>{{ data.amount }}</td>
                    </tr>
                  </template>
                  <tr v-else>
                    <td colspan="50" class="text-center text-danger">
                      No matched data!
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="tab-pane fade" id="all-data">
              <table class="table partner-table">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>Transaction ID</th>
                    <th>Name</th>
                    <th>bKash No</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in bkashPaymentData" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ data.transactionId }}</td>
                    <td>{{ data.name }}</td>
                    <td>{{ data.bkashNo }}</td>
                    <td>{{ data.amount }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <h6
          class="disburse-message"
          v-if="nonDisbursedMatchedDataWithBkashReport?.length"
        >
          Do you want to disburse all the matched bills?
        </h6>
      </div>
    </div>
    <div
      :class="{
        'modal-footer': true,
        'no-border': bkashPaymentData?.length
      }"
    >
      <button class="btn btn-cancel" data-bs-dismiss="modal" aria-label="Close">
        Close
      </button>
      <button v-if="isLoading" class="btn btn-primary" type="button" disabled>
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        Loading...
      </button>
      <button
        v-else
        class="btn btn-primary"
        :disabled="!nonDisbursedMatchedDataWithBkashReport?.length"
        @click="disburseMatchedBills()"
      >
        Disburse
      </button>
    </div>
  </div>
</template>

<script>
import readXlsxFile from 'read-excel-file';
import http from '../../config/axios';
export default {
  props: ['paymentList'],
  data() {
    return {
      isLoading: false,
      bkashPaymentData: null,
      nonDisbursedMatchedDataWithBkashReport: null
    };
  },
  watch: {
    paymentList: {
      handler: function () {
        this.emptyPaymentData();
      },
      deep: true
    }
  },
  methods: {
    emptyPaymentData() {
      this.$refs.excelFileInputField.value = null;
      this.bkashPaymentData = null;
      this.nonDisbursedMatchedDataWithBkashReport = null;
    },
    loadExcel(event) {
      let xlsxfile = event.target.files ? event.target.files[0] : null;
      readXlsxFile(xlsxfile).then((rows) => {
        this.bkashPaymentData = [];
        rows.forEach((row) => {
          let nameAndBkashNo = this.getNameAndBkashNoFromExcelRow(row);
          if (
            nameAndBkashNo?.length === 2 &&
            row[4] &&
            row[6] &&
            typeof row[6] === 'number'
          ) {
            this.bkashPaymentData.push({
              transactionId: row[4],
              name: nameAndBkashNo[0],
              bkashNo: nameAndBkashNo[1],
              amount: row[6]
            });
          }
        });
        this.findNonDisbursedMatchedDataWithBkashReport();
      });
    },
    getNameAndBkashNoFromExcelRow(row) {
      let nameAndBkashNo = null;
      if (row[5] && typeof row[5] === 'string') {
        let slicingIndex = this.getSlicingIndexForBkashNoAndName(row[5]);

        if (typeof slicingIndex === 'number') {
          let string = row[5].slice(slicingIndex).split(' - ');
          if (string?.length === 2) {
            nameAndBkashNo = [string[1], string[0]];
          }
        }
      }
      return nameAndBkashNo;
    },
    getSlicingIndexForBkashNoAndName(string) {
      let slicingIndex = null;

      for (let i = 0; i < string.length - 1; i++) {
        if (string[i] == 0 && string[i + 1] == 1) {
          let noAndNameFound = false;
          for (let j = i; j < string.length - 2; j++) {
            if (
              string[j] == ' ' &&
              string[j + 1] == '-' &&
              string[j + 2] == ' '
            ) {
              noAndNameFound = true;
              break;
            }
          }
          if (noAndNameFound) {
            slicingIndex = i;
            break;
          }
        }
      }

      return slicingIndex;
    },
    findNonDisbursedMatchedDataWithBkashReport() {
      if (this.bkashPaymentData?.length) {
        this.nonDisbursedMatchedDataWithBkashReport = [];
        let paymentList = [...this.paymentList];

        this.bkashPaymentData.forEach((bkashData) => {
          for (let i = 0; i < paymentList.length; i++) {
            let paymentData = paymentList[i];
            if (
              paymentData.payment_method === 'bkash' &&
              bkashData.bkashNo === paymentData.account_no &&
              bkashData.amount === paymentData.debit &&
              // parseInt(bkashData.amount) === parseInt(paymentData.debit) &&
              paymentData.total_bill_requested_and_disbursed < 2
            ) {
              this.nonDisbursedMatchedDataWithBkashReport.push({
                transactionId: bkashData.transactionId,
                name: bkashData.name,
                bkashNo: bkashData.bkashNo,
                amount: paymentData.debit,
                bills_id: paymentData.bills_id
              });
              paymentList.splice(i, 1);
              break;
            }
          }
        });

        paymentList = [];
      } else {
        this.nonDisbursedMatchedDataWithBkashReport = null;
      }
    },
    disburseMatchedBills() {
      if (this.nonDisbursedMatchedDataWithBkashReport?.length) {
        let data = [];
        this.nonDisbursedMatchedDataWithBkashReport.forEach((element) => {
          data.push({
            bill_id: element.bills_id,
            transaction_id: element.transactionId
          });
        });

        this.isLoading = true;
        http
          .patch(`/v2/partners/transaction/bulk/disbursement`, {
            transaction_data: data
          })
          .then((response) => {
            this.isLoading = false;
            this.emptyPaymentData();
            this.$refs.modalCloseBtn.click();
            this.$emit('refreshData');
            this.$partnerSwal.quickSuccessAlert.fire({
              title: 'Success!',
              text: response.data?.message
            });
          })
          .catch((error) => {
            this.isLoading = false;
            this.$partnerSwal.errorToast.fire({
              title: 'Error!',
              text: error.response?.data?.message
            });
          });
      } else {
        this.$partnerSwal.warningToast.fire({
          title: 'Warning',
          text: 'No matched requested data found to disburse!'
        });
      }
    }
  }
};
</script>

<style scoped>
.partner-nav {
  width: 100%;
  float: none;
}
.disburse-message {
  margin: 0;
  /* text-align: right; */
}
</style>
